import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useActivitiesStore } from '@/store/activities';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/activities/activities.config';

import Table from '@/components/views/TableView.vue';
import MobileCardsView from '@/components/views/MobileCardsView.vue';
import Calendar from '@/components/views/calendar/Container.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

import { useLayoutField } from '@/composables/useLayoutField';
import { CARD_FIELDS, DEFAULT_CARD_ORDER } from '@/components/modules/sales/sales.config';
import { useDisplay } from 'vuetify';

const moduleName = 'Activities';

export default /*@__PURE__*/_defineComponent({
  __name: 'Activities',
  props: {
    clientId: {},
    client: {}
  },
  setup(__props: any) {

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const preferencesStore = usePreferencesStore();
const activitiesStore = useActivitiesStore();

const currentView = useLayoutField(moduleName, 'currentView');

const props = __props;

const { clientId } = props;

const buildParams = (params: any) => {
  // Solo agrega el filtro si clientId está definido y es válido
  if (clientId !== undefined && clientId !== null) {
    return {
      ...params,
      'filter[subject_id]': clientId,
      'filter[subject]': "clients",
    };
  }
  return params;
};

const {
  create,
  update,
  remove,
  exportCsv
} = useModuleLayoutFetcher(
  moduleName,
  (params) => activitiesStore.fetchActivities(buildParams(params)),
  {
    create: activitiesStore.createActivity,
    update: (data) => activitiesStore.updateActivity(data.id, data),
    remove: activitiesStore.deleteActivity,
    exportCsv: activitiesStore.exportCSV
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => activitiesStore.activities);


return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(ViewsContainer, {
        moduleName: moduleName,
        listViewComponent: Table,
        calendarViewComponent: Calendar,
        filterComponent: Filter,
        data: data.value,
        config: '@/components/modules/activities/activities.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        onDelete: _unref(remove),
        exportCsv: _unref(exportCsv),
        show_toolbar: true,
        show_pagination: _unref(currentView)!='calendar',
        title: {singular:'Actividad', plural:'Actividades'},
        key: moduleName,
        client: _ctx.client,
        clientId: _unref(clientId)
      }, null, 8, ["data", "onCreate", "onUpdate", "onDelete", "exportCsv", "show_pagination", "client", "clientId"]))
    ]),
    _: 1
  }))
}
}

})